import React from 'react';
import { TextField, IconButton, CircularProgress, Typography, Box, Stack } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ChatInput = ({
    disabled,
    text,
    setText,
    placeholder,
    send,
    sending,
    info
}) => {
    const handleSend = () => {
        if (!sending) {
            send(text);
        }
    };

    return (
        <div>
            <TextField
                disabled={disabled}
                size="small"
                value={text}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey && text.length > 0 && !disabled) {
                        e.preventDefault(); // Prevents newline in the text field
                        handleSend();
                    }
                }}
                onChange={(e) => setText(e.target.value)}
                placeholder={placeholder}
                multiline
                fullWidth
                InputProps={{
                    endAdornment: (
                        <IconButton
                            disabled={text.length === 0 || disabled}
                            onClick={handleSend}>
                            {
                                sending ?
                                    <CircularProgress size={20} /> :
                                    <SendIcon />
                            }
                        </IconButton>
                    ),
                }}
            />
            {
                info &&
                <Stack
                    direction="row"
                    spacing={0.5}
                    mt={0.6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                    <InfoOutlinedIcon /> <Typography variant="caption">
                        {info}
                    </Typography>
                </Stack>
            }
        </div>
    );
};

export default ChatInput;